import React from 'react';
import Button from 'Modals/components/Button';
import PropTypes from 'prop-types';
import { closeModal } from 'Modals/ModalActions';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    closeModal,
  }, dispatch)
);

export class SignatureCancelSurveyModalBodyContent extends React.Component {

  constructor() {
    super();
    this.state = {
      response: null,
      cancelReason: '',
      selection: null,
    };
    this.onChange = this.changeSelection.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onChangeText = this.changeText.bind(this);
  }

  componentDidMount() {
    window._track('Viewed Cancel Request Survey', 'My Documents');
  }

  changeSelection(e) {
    const cancelReason = e.target.value === 'Other' ? ` ${this.state.cancelReason}` : '';
    this.setState({
      response: `${e.target.value}${cancelReason} | Cancel Request Survey`,
      selection: e.target.value,
    });
  }

  changeText(e) {
    this.setState({
      cancelReason: `${e.target.value}`,
    });

    if (this.state.selection === 'Other') {
      this.setState({
        response: `${this.state.selection} ${e.target.value} | Cancel Request Survey`,
      });
    }
  }

  closeModal() {
    if (this.state.response) {
      this.props.closeModal(this.props.modalType);
    }
  }

  render() {
    return (
      <div className="cancel-sig-survey">
        <h4>Request Canceled. Do you mind sharing why you canceled your request?</h4>

        <form id="cancelForm">
          <input
            type="radio"
            name="cancelReason"
            value="Don't understand feature"
            id="understand"
            onChange={this.onChange}
          />
          <label htmlFor="understand">I don&rsquo;t understand what this feature is.</label>

          <input
            type="radio"
            name="cancelReason"
            value="Still need to edit"
            id="edit"
            onChange={this.onChange}
          />
          <label htmlFor="edit">I still need to edit my document.</label>

          <input
            type="radio"
            name="cancelReason"
            value="Only one signing"
            id="oneSigning"
            onChange={this.onChange}
          />
          <label htmlFor="oneSigner">
            I am the only one signing this document and therefore
            do not need to send it to someone else.
          </label>

          <input
            type="radio"
            name="cancelReason"
            value="Don't need signature"
            id="noSignature"
            onChange={this.onChange}
          />
          <label htmlFor="noSignature">I don&rsquo;t need a signature on this document.</label>

          <input
            type="radio"
            name="cancelReason"
            value="Other"
            id="other"
            onChange={this.onChange}
          />
          <label htmlFor="other">Other <i>(please explain)</i> </label>

          <textarea name="cancelReason" id="otherReason" onChange={this.onChangeText} />
        </form>

        <div className="buttons">
          <Button
            buttonOnClick={this.closeModal}
            buttonText="Submit Answer"
            trackCategory={this.state.response}
            trackAction="My Documents"
            form="cancelForm"
            type="submit"
          />
        </div>
      </div>
    );
  }
}

SignatureCancelSurveyModalBodyContent.defaultProps = {
  modalType: '',
};

SignatureCancelSurveyModalBodyContent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalType: PropTypes.string,
};

const ConnectedSignatureCancelSurveyModalBody = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(SignatureCancelSurveyModalBodyContent);
export default ConnectedSignatureCancelSurveyModalBody;



// WEBPACK FOOTER //
// ./src-react/Modals/content/SignatureCancelSurveyBodyContent.jsx